// eslint-disable-next-line no-restricted-imports
import { TFunction } from 'i18next';
import { Badge, Flex } from '@mantine/core';
import { PermissionRoleWithOwnerEnum } from '@dealstack/shared/lib/generated';

interface Props {
	permissionRoles: PermissionRoleWithOwnerEnum[];
	t: TFunction;
}

export const PermissionsCell = ({ permissionRoles, t }: Props) => {
	return (
		<Flex gap="0.5rem" wrap="wrap">
			{permissionRoles.map((role) => (
				<Badge
					data-testid={`permission-role-${role}`}
					key={role}
					color="gray.4"
					variant="outline"
					c="dark.4"
					fw={400}
				>
					{t(`invite_team_member.relation.${role}`)}
				</Badge>
			))}
		</Flex>
	);
};
